import {
  FilterMode,
  EsignatureWebhookEvent_OrderBy,
  EsignatureWebhookEvent,
  SortOrder,
  EsignatureWebhookEvent_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const esignatureWebhookEventService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.esignatureWebhookEventOne({ id });
    return result.esignatureWebhookEventOne as EsignatureWebhookEvent;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: EsignatureWebhookEvent_OrderBy[] | null = null,
    filter: EsignatureWebhookEvent_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: EsignatureWebhookEvent_Filter | undefined;
    if (searchValue !== "") {
      where = {
        OR: [
          {
            eventType: { contains: searchValue, mode: FilterMode.Insensitive },
          },
          {
            externalEventId: {
              contains: searchValue,
              mode: FilterMode.Insensitive,
            },
          },
        ],
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.esignatureWebhookEventListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [{ eventType: SortOrder.Asc }, { externalEventId: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.esignatureWebhookEventListWithOffset
    ) as EsignatureWebhookEvent[];
    return { list, orderBy };
  },
};
